import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.049 3.95H3.613A.613.613 0 0 0 3 4.562v3.979c0 .338.274.613.612.613h11.069a4.615 4.615 0 0 1-2.293-1.225H4.225V5.175h6.807a4.679 4.679 0 0 1 .017-1.225Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M17 11.46a.612.612 0 0 0-.613-.613H7.225a.613.613 0 0 0-.612.612v3.98c0 .338.274.612.612.612h9.162a.613.613 0 0 0 .613-.613V11.46Zm-9.162.612h7.937v2.754H7.837v-2.754ZM15.75 1.8a.7.7 0 0 1 .7.7v1.3h1.3a.7.7 0 1 1 0 1.4h-1.3v1.3a.7.7 0 1 1-1.4 0V5.2h-1.3a.7.7 0 1 1 0-1.4h1.3V2.5a.7.7 0 0 1 .7-.7Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=AddNestedSubItemIcon20.js.map